import { render, staticRenderFns } from "./SpaceSettingsAvatar.vue?vue&type=template&id=6331f870&scoped=true&"
import script from "./SpaceSettingsAvatar.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./SpaceSettingsAvatar.vue?vue&type=style&index=0&id=6331f870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331f870",
  null
  
)

export default component.exports